// Authentication Types
export interface AuthCredentials {
  email: string;
  password: string;
}

export interface RegisterData {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  role: 'STUDENT' | 'TEACHER';
  additionalInfo?: StudentRegisterData | TeacherRegisterData;
}

export interface StudentRegisterData {
  dateOfBirth?: Date;
  gradeLevel?: string;
  parentEmail?: string;
}

export interface TeacherRegisterData {
  bio: string;
  subjects: string[];
  qualifications: Array<{
    title: string;
    institution: string;
    year: number;
  }>;
  hourlyRate: number;
}

// UserStatus is now defined in kernel/enums — re-export for backwards compatibility
export { UserStatus } from '../kernel/enums';

/**
 * Teacher profile for future verification data
 * This is a placeholder structure that will be expanded in Epic 2
 */
export interface TeacherProfile {
  verificationStatus?: 'PENDING' | 'VERIFIED' | 'REJECTED';
  verificationDate?: string;
  documents?: {
    id?: string;
    certification?: string;
    backgroundCheck?: string;
  };
  bio?: string;
  subjects?: string[];
  qualifications?: Array<{
    title: string;
    institution: string;
    year: number;
  }>;
  hourlyRate?: number;
}

export interface AuthResponse {
  accessToken: string;
  refreshToken: string;
  user: {
    id: string;
    email: string;
    firstName: string;
    lastName: string;
    role: string;
    status: string;
  };
}

export interface OTPVerification {
  email: string;
  code: string;
}

export interface PasswordReset {
  email: string;
  code: string;
  newPassword: string;
}

export interface TokenPayload {
  sub: string;
  email: string;
  role: string;
  iat: number;
  exp: number;
}